import { useMemo } from 'react'

import { matchFilterNumber, sortArrayBy } from '@domain-group/javascript-utils'

import { useWatchEntityUpdates } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { PublicationOptionValueModel } from '@models/types'

const watchEntityKeys = ['publicationOptionValues']

type PublicationOptionValueFilters = {
  publication_option_id?: number,
}

type UsePublicationOptionValuesOptions = {
  entityKey?: string,
  filters?: PublicationOptionValueFilters,
  performHttpRequests?: boolean,
  requestOptions?: object,
}

const usePublicationOptionValues = (options: UsePublicationOptionValuesOptions = {}) => {
  const { filters } = options
  const {
    publication_option_id: filterPublicationOptionId,
  } = filters || {}

  const {
    updatedEntities: { publicationOptionValues: publicationOptionValuesUpdatedAt },
  } = useWatchEntityUpdates(watchEntityKeys)

  const publicationOptionValues: Record<string, PublicationOptionValueModel> = useSelector(
    reduxState => reduxState.entities.publicationOptionValues,
  )

  const filteredPublicationOptionValues = useMemo(() => {
    const filtered = Object.values(publicationOptionValues).filter((value) => {
      const { publication_option_id } = value

      const matchPublicationOption = matchFilterNumber(publication_option_id, filterPublicationOptionId)

      return matchPublicationOption
    })

    return sortArrayBy(filtered, 'asc', 'title')
  }, [publicationOptionValuesUpdatedAt, JSON.stringify(filters)])

  const hasFilteredPublicationOptionValues = !!filteredPublicationOptionValues.length

  return {
    filteredPublicationOptionValues,
    hasFilteredPublicationOptionValues,
    publicationOptionValues: Object.values(publicationOptionValues),
    publicationOptionValuesUpdatedAt,
  }
}

export default usePublicationOptionValues
